export enum CurrentMatchStoreStatus {
  Loading = 'Loading',
  Joining = 'Joining',
  Accepting = 'Accepting',
  Declining = 'Declining',
  Withdrawing = 'Withdrawing',
  ViewingAnimation = 'ViewingAnimation',
  Forfeiting = 'Forfeiting',
}
